export default __webpack_public_path__ + "static/media/add_user_icon.d7368cf5.svg";